export default () => {
    return <div className="loader-container">
        <div className="loader"></div>
    </div>
}